import { IconButton as MuiIconButton } from '@mui/material_v7';
import { useTheme } from '@mui/material_v7/styles';
import { forwardRef } from 'react';

import type { IconButtonProps } from './types';

/**
 * Add classes 'square' to make the button square.
 * classes={{ root: 'square' }}
 */
const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>((props, ref) => {
  const { outline = false, loading = false, disabled, color, ...rest } = props;
  const theme = useTheme();

  const borderColor = color === 'error' ? theme.palette.error[300] : 'currentColor';
  const outlineStyles = outline ? { border: `1px solid ${borderColor}` } : false;

  return (
    <MuiIconButton
      ref={ref}
      disabled={loading || disabled}
      aria-busy={loading || undefined}
      sx={[outlineStyles]}
      color={color}
      {...rest}
    />
  );
});

export { IconButton };
